import MappingTabs from './MappingTabs'
export default MappingTabs



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/index.js